import { useEffect, useState } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import httpRequest from "../../../utils/Http";
import { getFilteredTimeslots } from "../../../utils/HelperFunction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ApproveAssignBooking = ({
  setFormData,
  setReload,
  closeForm,
  formData,
}) => {
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setSubmit] = useState(false);
  const [appointmentDate, setAppointmentDate] = useState(
    formData.booking_date
  );
  const [timeslotList, setTimeslotList] = useState([]);
  useEffect(() => {
    if (formData?.appointment_date) {
      setTimeslotList(getFilteredTimeslots(formData.appointment_date));
    }
  }, [formData?.appointment_date]);

  useEffect(() => {

    if(formData?.booking_date){
      setTimeslotList(getFilteredTimeslots(formData.booking_date))
    }

  }, [formData?.booking_date])

  const validateForm = (value) => {
    const errors = {};

    if (!value.bid || !value.sf_id) {
      errors.bid = "Mandatory Field is required";
    }

    if (!value.timeslot && value.action === 1) {
      errors.timeslot = "Timeslot is required";
    }

    if (!value.remarks && value.action === 2) {
      errors.remarks = "Remarks is required";
    }
    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validateForm(formData));
    setSubmit(true);
  };

  useEffect(() => {
    (async () => {
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        setSubmit(false);
        const data = await httpRequest(
          "processbookingassign",
          formData,
          "POST"
        );

        if (data.status === true && data.message) {
          toast.success(data.message);
          setReload(true);
          closeForm();
          setFormData({});
        } else {
          toast.error(data.message);
        }
      }
    })();
  }, [isSubmit, formErrors]);

  return (
    <>
      {(formData.action === 1 || formData.action === 2) && (
        <div className="form-overlay">
          <div className="form-container" style={{ maxWidth: "500px" }}>
            <div className="form-content">
              <form id="assignPartner" onSubmit={onSubmitHandler}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card" style={{ marginBottom: "0px" }}>
                      <div className="card-header">
                        <h3 className="card-title">
                          {formData.action === 1
                            ? "Approve Assignment"
                            : "Reject Assignment"}
                        </h3>
                        <button
                          type="button"
                          className="btn btn-sm btn-dark"
                          onClick={closeForm}
                          style={{ float: "right" }}
                        >
                          X
                        </button>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          {formData.action === 1 && (
                            <>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <label>
                                    Appointment Date *{" "}
                                    <span style={{ color: "red" }}>
                                      {formErrors.appointment_date}
                                    </span>
                                  </label>
                                  <div className="col-md-12">
                                    <DatePicker
                                      className="form-control text-capitalize"
                                      minDate={new Date()}
                                      dateFormat="dd/MM/yyyy"
                                      selected={appointmentDate}
                                      placeholderText="Select Appointment Date"
                                      onChange={(date) => {
                                        setFormData({
                                          ...formData,
                                          appointment_date: date,
                                        });
                                        setAppointmentDate(date);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div className="form-group">
                                    <label>
                                      Timeslot *{" "}
                                      <span style={{ color: "red" }}>
                                        {formErrors.sc_id}
                                      </span>
                                    </label>
                                    <Select
                                      name="timeslot"
                                      placeholder="Select Timeslot"
                                      value={
                                        timeslotList.find(
                                          (option) =>
                                            option.value === formData.timeslot
                                        ) || null
                                      }
                                      options={timeslotList}
                                      onChange={(val) => {
                                        setFormData((prev) => ({
                                          ...prev,
                                          timeslot: val.value,
                                        }));
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>
                                Remarks {formData.action === 2 && "* "}
                                <span style={{ color: "red" }}>
                                  {formErrors.remarks}
                                </span>
                              </label>
                              <textarea
                                name="remarks"
                                id="remarks"
                                value={formData.remarks}
                                placeholder="Enter remarks"
                                className="form-control"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    [e.target.name]: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="card-footer text-center"
                        style={{
                          marginBottom: "60px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary col-md-12"
                          style={{ margin: "0px" }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ApproveAssignBooking;
